import AppDataService from "./AppDataService";

const COMMON_BASE = 'RightsManagement'

export default class RightsManagementDataService {

    static async exportToExcelMemberUserPayers() {
        return await AppDataService.get(`${COMMON_BASE}/ExportToExcelMemberUserPayers`, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

    static async exportMemberUser() {
        return await AppDataService.get(`${COMMON_BASE}/ExportMemberUser`, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

    static async changeUserStatus(data) {
        const { MemberId, IsEnabled } = data;

        return await AppDataService.put(`${COMMON_BASE}/EnableDisableMember?MemberId=${MemberId}&IsEnable=${IsEnabled}`, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

    static async changeAssignPayers(data) {
        const { MemberId, IsEnabled } = data;

        return await AppDataService.put(`${COMMON_BASE}/EnableDisableAssignAllPayer?MemberId=${MemberId}&IsEnable=${IsEnabled}`, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

    static async updateMemberUser(data) {
        return await AppDataService.put(`${COMMON_BASE}/UpdateMemberUser`, data);
    }

    static async createMemberUser(data) {
        return await AppDataService.post(`${COMMON_BASE}/CreateMemberUser`, data);
    }

    static async deleteMember(data) {
        const { MemberId } = data;
        return await AppDataService.delete(`${COMMON_BASE}/DeleteMember?MemberId=${MemberId}`, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

    static async getTemplate() {
        return await AppDataService.get(`${COMMON_BASE}/GetTemplate`, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

    static async uploadSheet(data) {
        return await AppDataService.post(`${COMMON_BASE}/UploadSheet`, data)
    }

    static async bulkSave() {
        return await AppDataService.get(`${COMMON_BASE}/BulkSave`, {
            headers: {
                'Content-Type': 'application/json'
            },
        })
    }

    static async getGroupIDs() {
        return await AppDataService.get(`${COMMON_BASE}/GetGroupIds`, {
            headers: {
                'Content-Type': 'application/json'
            },
        })
    }

    static async loadPermissions() {
        return await AppDataService.get(`${COMMON_BASE}/LoadPermissions`, {
            headers: {
                'Content-Type': 'application/json'
            },
        })
    }

    static async getThresholdAmount() {
        return await AppDataService.get(`${COMMON_BASE}/GetThresholdAmount`, {
            headers: {
                'Content-Type': 'application/json'
            },
        })
    }

    static async getRightsLabels() {
        return await AppDataService.get(`${COMMON_BASE}/GetRightsLabels`, {
            headers: {
                'Content-Type': 'application/json'
            },
        })
    }

    static async reRequest(data) {
        return await AppDataService.get(`${COMMON_BASE}/ReRequest?Email=${data}`, {
            headers: {
                'Content-Type': 'application/json'
            },
        })
    }

    static async getMemberRoles() {
        return await AppDataService.get(`${COMMON_BASE}/GetMemberRoles`, {
            headers: {
                'Content-Type': 'application/json'
            },
        })
    }

    static async assignGroupID(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetGroupIds`, { params })
    }

    static async getRolesPermissions(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetPermissionsForRole`, { params })
    }

    static async getAssignedPayersList(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetMemberPayersList`, { params })
    }

    static async getDisabledPermissions() {
        return await AppDataService.get(`${COMMON_BASE}/GetDisablePermissions`)
    }

    static async checkIfGroupIdCheckedForMember(params) {
        return await AppDataService.get(`${COMMON_BASE}/CheckIfGroupIdCheckedForMember`, { params })
    }

    static async updateThresholdAmount(amount) {
        return await AppDataService.put(`${COMMON_BASE}/SetThresholdAmount?amount=${amount}`)
    }

    static async updatePermissions(permissions) {
        return await AppDataService.post(`${COMMON_BASE}/UpdatePermissions`, permissions)
    }

    static async assigningPayersWithGroupId(params) {
        const { groupIDs, memberID, assign } = params;
        return await AppDataService.put(`${COMMON_BASE}/AssigningPayersWithGroupId?groupIds=${groupIDs}&memberId=${memberID}&assign=${assign}`,)
    }

    static async managePayersForMember(data) {
        return await AppDataService.post(`${COMMON_BASE}/ManagePayersForMember`, data)
    }

    static async getUserRights() {
        return await AppDataService.get(`${COMMON_BASE}/GetUserRights`)
    }

    static async getViewNoticesRight() {
        return await AppDataService.get(`${COMMON_BASE}/ViewNotices`)
    }

    static async reviewAndApprovePayers(params) {
        return await AppDataService.get(`${COMMON_BASE}/ReviewAndApprovePayers`, { params })
    }

    static async reviewAndApproveStatuses() {
        return await AppDataService.get(`${COMMON_BASE}/ReviewAndApproveStatuses`)
    }

    static async reviewAndApproveGridData(params) {
        return await AppDataService.get(`${COMMON_BASE}/ReviewAndApproveGridData`, { params })
    }

    static async approveForms({ formIds, payerId, formName, payerName, taxyear }) {
        return await AppDataService.put(`${COMMON_BASE}/ApproveForms?formIds=${formIds}&payerId=${payerId}&formName=${formName}&payerName=${payerName}&taxyear=${taxyear}`)
    }

    static async reviewRejectedGridData(params) {
        return await AppDataService.get(`${COMMON_BASE}/ReviewRejectedGridData`, { params })
    }

    static async resubmitRejectedForms({ formIds, payerId, formName, payerName, taxyear, remarks }) {
        return await AppDataService.put(`${COMMON_BASE}/ResubmitForms?formIds=${formIds}&payerId=${payerId}&formName=${formName}&payerName=${payerName}&taxyear=${taxyear}&remarks=${remarks}`)
    }

    static async reviewApproveExport(params) {
        return await AppDataService.get(`${COMMON_BASE}/ReviewApproveExport`, { params })
    }

    static async reviewApproveRejectForms({ formIds, payerId, formName, payerName, taxyear, remarks }) {
        return await AppDataService.put(`${COMMON_BASE}/RejectForms?formIds=${formIds}&payerId=${payerId}&formName=${formName}&payerName=${payerName}&taxyear=${taxyear}&remarks=${remarks}`)
    }

    static async reviewApproveDeleteForms({ payerid, formId, taxyear, Formtypeid, }) {
        return await AppDataService.delete(`${COMMON_BASE}/ReviewDeleteForms?payerid=${payerid}&formId=${formId}&taxyear=${taxyear}&Formtypeid=${Formtypeid}`)
    }

    static async submitforReview({ formIds, payerId, formName, payerName, taxyear, formtypeId, reviewerIds }) {
        return await AppDataService.put(`${COMMON_BASE}/SubmitforReview?formIds=${formIds}&payerId=${payerId}&formName=${formName}&formtypeId=${formtypeId}&payerName=${payerName}&taxyear=${taxyear}&reviewerIds=${reviewerIds}`)
    }

    static async assignFormsUsers(params) {
        return await AppDataService.get(`${COMMON_BASE}/AssignFormsUsers`, { params })
    }

    static async IsAllowMemberToCreate() {
        return await AppDataService.get(`${COMMON_BASE}/IsAllowMemberToCreate`)
    }

    static async getStatePayrollStateNames() {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollStates`);
    }
    static async getStatePayrollFormNames(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollFormNames?stateName=${params}`)
    }
}